import {
  Component,
  ContentChild,
  Directive,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SecurePipe } from '@shared/pipes/secure.pipe';
import { FormsModule } from '@angular/forms';

@Directive({
  selector: '[appCardThumbnail]',
  standalone: true,
})
export class CardThumbnailDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
@Directive({
  selector: '[appCardDetail]',
  standalone: true,
})
export class CardDetailDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}

@Component({
  selector: 'app-grid-view-card',
  standalone: true,
  templateUrl: './grid-view-card.component.html',
  styleUrls: ['./grid-view-card.component.scss'],
  imports: [CommonModule, TranslateModule, SecurePipe, FormsModule],
})
export class GridViewCardComponent {
  @Input() thumbnail_img: string | null | undefined;
  @Input() thumbnailHeight = 150;
  @Input() isProtected = false;

  @Input() isSelectedCard = false;
  @Input() disabled = false;
  @Input() hasCheck = true;
  @Input() checked: boolean;
  @Output() checkedChange = new EventEmitter<boolean>();

  @Output() clickCard = new EventEmitter<void>();

  @ContentChild(CardThumbnailDirective)
  cardThumbnail: CardThumbnailDirective;
  @ContentChild(CardDetailDirective)
  cardDetail: CardDetailDirective;
}
